import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Svg from '../Svg'

import styles from './ArrowIcon.module.scss'

const propTypes = {
  className: PropTypes.string,
}

const ArrowIcon = ({ className }) => (
  <Svg
    className={classnames(className, styles.root)}
    viewBox='0 0 9 6'
    width='6'
    height='9'
  >
    <path d='M4.5 -8.7024e-07L0 6L9 6L4.5 -8.7024e-07Z' />
  </Svg>
)

ArrowIcon.propTypes = propTypes

export { ArrowIcon }
